import { ref } from 'vue';
import Component from './component.vue'

export default {
  install: (app, options) => {
    app.component('notifications', Component);

    const getRandomString = (length = 10) => {
      let className = "";
      const characters = "abcdefghijklmnopqrstuvwxyz";
      for (var i = 0; i < length; i++) {
        className += characters.charAt(Math.floor(Math.random() * characters.length));
      }

      return className;
    }

    const notifications = ref([]);

    const show = (notification, timeout = 5000) => {
      const id = getRandomString();

      notifications.value.push({
        id: id,
        class: notification.class, // warning, error
        title: notification.title,
        status: notification.status,
        descr: notification.descr,
      });

      if (timeout) {
        setTimeout(() => {
          hide(id);
        }, timeout);
      }
    }

    const hide = (id) => {
      notifications.value.filter((element, index) => {

        if (element.id == id) {
          notifications.value.splice(index, 1);
        }
      });
    }

    const notification = { notifications, show, hide };

    app.config.globalProperties.$notification = notification;
    app.provide('$notification', notification);
  }
}